module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.game) ? _c('login-view') : (_vm.isDead) ? _c('dead-view') : (_vm.result) ? _c('result-view', {
    attrs: {
      "result": _vm.result
    }
  }) : (_vm.page) ? _c(_vm.page, {
    tag: "component"
  }) : _c('span', {
    staticClass: "raw"
  }, [_vm._v(_vm._s(_vm.game))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-166ed7e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/routes/HomeView/index.vue
// module id = 312
// module chunks = 0